import { Stack, StandaloneTable, Typography, useTableState } from '@optimus-web/core';
import { Product } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { useColumns } from './useColumns';
import { UseReservationProductOrdersParams, useReservationProductOrders } from './useReservationProductOrders';

export type ProductsListProps = UseReservationProductOrdersParams;

export const ProductsList = (props: ProductsListProps) => {
    const { products, counts, totalCount } = useReservationProductOrders(props);
    const [tableState, setTableState] = useTableState<Product>({ pagination: { show: false } });
    const columns = useColumns(counts);

    return (
        <Stack spacing="100" vertical>
            <Typography textStyle="bodyMediumStrong" as="div">
                <LocalizedText
                    textKey={TextKey.GuestInHouseReportProductsTotalItemsCount}
                    substitutes={{ count: totalCount }}
                />
            </Typography>
            <StandaloneTable
                columns={columns}
                state={tableState}
                onStateChange={setTableState}
                uniqueRowId="id"
                data={products}
                amountOfRows={products.length}
            />
        </Stack>
    );
};
